/**
 * Created by rickborst on 24/04/2017.
 */

import _ from 'lodash';

/**
 * Validator fo the fetch views response.
 *
 * @param {Object} response - Fetch views response.
 * @returns {boolean} Whether the response is valid or not.
 */
export function isValidFetchResponse (response) {

    return !_.get(response, ['result', 'error']);
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/validators/views.js